import {
    ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL,
    ACCOUNTS_PROMILES_REQUEST_REQUEST,
    ACCOUNTS_PROMILES_REQUEST_RESULT
} from 'Redux/actionTypes'

export const accountsPromilesRequestOpenModal = (data) => ({
    type: ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL,
    payload: data
})

export const accountsPromilesRequestRequest = (data) => ({
    type: ACCOUNTS_PROMILES_REQUEST_REQUEST,
    payload: data
})

export const accountsPromilesRequestResult = (data) => ({
    type: ACCOUNTS_PROMILES_REQUEST_RESULT,
    payload: data
})